import { useCallback } from 'react'

const useGetInvalidFields = params => {
  const {
    email, captcha, errors,
  } = params

  return useCallback(
    () => {
      const validation = []
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i
      if (!emailRegex.test(email)) {
        validation.push({
          email: 'Provide a valid email address.',
        })
      }
      if (!captcha) {
        validation.push({
          captcha: 'Verification failed. Please try again.',
        })
      }

      if (validation.length) {
        const validationErrors = validation.reduce(
          (prev, curr) => ({
            ...prev,
            ...curr,
          }),
          {},
        )

        if (validationErrors) {
          return {
            ...errors,
            ...validationErrors,
          }
        }
      }

      return null
    },
    [email, captcha, errors],
  )
}

export default useGetInvalidFields
